import * as React from 'react';
import useId from '@mui/utils/useId';
import { ChartStore } from "../plugins/utils/ChartStore.js";
import { CHART_CORE_PLUGINS } from "../plugins/corePlugins/index.js";
export function useChartApiInitialization(inputApiRef) {
  const fallbackPublicApiRef = React.useRef({});
  if (inputApiRef) {
    if (inputApiRef.current == null) {
      // eslint-disable-next-line react-compiler/react-compiler
      inputApiRef.current = {};
    }
    return inputApiRef.current;
  }
  return fallbackPublicApiRef.current;
}
let globalId = 0;
export function useCharts(inPlugins, props) {
  const plugins = React.useMemo(() => [...CHART_CORE_PLUGINS, ...inPlugins], [inPlugins]);
  const defaultChartId = useId();
  const pluginParams = {
    id: defaultChartId
  }; // To generate when plugins use params.
  const instanceRef = React.useRef({});
  const instance = instanceRef.current;
  const publicAPI = useChartApiInitialization(props.apiRef);
  const innerSvgRef = React.useRef(null);
  const storeRef = React.useRef(null);
  if (storeRef.current == null) {
    // eslint-disable-next-line react-compiler/react-compiler
    globalId += 1;
    const initialState = {
      // TODO remove when the interaction moves to plugin
      interaction: {
        item: null,
        axis: {
          x: null,
          y: null
        }
      },
      cacheKey: {
        id: globalId
      }
    };
    plugins.forEach(plugin => {
      if (plugin.getInitialState) {
        Object.assign(initialState, plugin.getInitialState({
          id: defaultChartId
        }));
      }
    });
    storeRef.current = new ChartStore(initialState);
  }
  const runPlugin = plugin => {
    const pluginResponse = plugin({
      instance,
      params: pluginParams,
      plugins: plugins,
      store: storeRef.current,
      svgRef: innerSvgRef
    });
    if (pluginResponse.publicAPI) {
      Object.assign(publicAPI, pluginResponse.publicAPI);
    }
    if (pluginResponse.instance) {
      Object.assign(instance, pluginResponse.instance);
    }
  };
  plugins.forEach(runPlugin);
  const contextValue = React.useMemo(() => ({
    store: storeRef.current,
    publicAPI,
    instance,
    svgRef: innerSvgRef
  }), [instance, publicAPI]);
  return {
    contextValue
  };
}